module.exports = __webpack_public_path__ + "static/img/part2.1f7a2f1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/part2.svg
// module id = lBGb
// module chunks = 0